module.exports = __webpack_public_path__ + "img/spinner-icon.fa5cf015.png";